import IconError from './icons/IconError'
import IconContrast from './icons/IconContrast'
import IconAlerts from './icons/IconAlerts'
import IconFeatures from './icons/IconFeatures'
import IconAria from './icons/IconAria'

function RenderCategoryHeadingIcon(props) {
  const { categoryName } = props

  switch (categoryName) {
    case 'Errors':
      return <IconError />
    case 'Contrast Errors':
      return <IconContrast />
    case 'Alerts':
      return <IconAlerts />
    case 'Features':
      return <IconFeatures />
    case 'ARIA':
      return <IconAria />
    default:
      return ''
  }
}
export default RenderCategoryHeadingIcon